import { render, staticRenderFns } from "./project_progress.vue?vue&type=template&id=0fb81c1c&scoped=true&"
import script from "./project_progress.vue?vue&type=script&lang=js&"
export * from "./project_progress.vue?vue&type=script&lang=js&"
import style0 from "./project_progress.vue?vue&type=style&index=0&id=0fb81c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb81c1c",
  null
  
)

export default component.exports